<template>
  <div>
    <Header />

    <div class="wrapper">
      <section class="detail">
        <p>3rd Album</p>
        <h1>アデヤカ</h1>
        <img :src="img" />
      </section>

      <section>
        <Event />
        <p>会場頒布価格 : 1500円</p>
      </section>

      <section class="xfd">
        <h1>クロスフェード</h1>
        <SoundCloud />
        <YouTube />
        <Niconico />
      </section>
      
      <section>
        <TrackList />
      </section>

    </div>
  </div>
</template>

<script>
import Header from '@/components/adeyaka/Header.vue';
import Event from '@/components/adeyaka/Event.vue';
import TrackList from '@/components/adeyaka/TrackList.vue';
import YouTube from '@/components/adeyaka/YouTube.vue';
import SoundCloud from '@/components/adeyaka/SoundCloud.vue';
import Niconico from '@/components/adeyaka/Niconico.vue';

export default {
  name: 'Adeyaka',
  components: { Event, TrackList, Header, YouTube, SoundCloud, Niconico },
  data() {
    return {
      img: require('@/assets/adeyaka/img/jacket.jpg'),
    };
  },
};
</script>

<style lang="scss">
body {
  background:#e6f5ff;
}
.wrapper {
  width: 300px;
  margin: 0 auto;
}
section {
  margin: 50px 0;
  h1 {
    font-size: 1.5em;
    line-height: 50px;
  }
}
.detail{
  p {
    margin: 0;
  }
  h1{
    font-size: 2.5em;
    margin-bottom: 20px;
  }
  .catch-copy {
    margin-bottom: 40px;
    text-align: center;
    opacity: 60%;
  }
}
img {
  width: 100%;
}
.xfd h1 {
  margin-bottom: 15px;
}

@media screen and (min-width: 768px){
  .wrapper {
    width: 700px;
  }
}
</style>
